import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderService } from 'src/app/services/loader.service';
import { LoaderComponent } from 'src/app/Components/loader/loader.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple'
    })
  ],
  declarations: [LoaderComponent],
  exports: [LoaderComponent],
  providers: [LoaderService]
})
export class LoaderModule { }
